export const useTagDialog = () => {
  const isOpen = ref(false)
  const containerNumbers = ref<string[]>([])

  const openTagDialog = (containers: string[]) => {
    containerNumbers.value = containers
    isOpen.value = true
  }

  const closeTagDialog = () => {
    isOpen.value = false
    containerNumbers.value = []
  }

  return {
    isOpen: readonly(isOpen),
    containerNumbers: readonly(containerNumbers),
    openTagDialog,
    closeTagDialog,
  }
}

const globalTagDialog = useTagDialog()

export const useGlobalTagDialog = () => globalTagDialog
